import Vue from 'vue'

export async function getBicis(context, [access_token]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'GET',
                url: '/bicis',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('bicis/setBicis', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function crearBici(context, [access_token, modelBici]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/bicis',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelBici
            })
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateBici(context, [access_token, modelBici]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/bicis/' + modelBici.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelBici
            })
            if (response.status == 200) {
                context.commit('bicis/actListBicis', response.data.data, { root: true })
               }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarBici(context, [access_token, bici_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/bicis/' + bici_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

         
           if (response.status == 200) {
            context.commit('bicis/actDeleteListBicis', bici_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}

export async function subirPosicion(context, [access_token, id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/subir_posicion',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    id
                }
            })
            if (response.status == 200) {
               return response;
            }else{
                return null;
            }
        }
    } catch (e) {
        return null;
    } 
}



export async function bajarPosicion(context, [access_token, id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/bajar_posicion',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    id
                }
            })
            if (response.status == 200) {
               return response;
            }else{
                return null;
            }
        }
    } catch (e) {
        return null;
    } 
}


